import { faGlobe } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import * as Flags from 'country-flag-icons/react/3x2'
import type React from 'react'
import { countryAlpha2, countryLabel } from './dashboardFormat'

// Bundled SVG flags keyed by ISO-2. The wall board runs Chromium on a Raspberry Pi, which ships no
// colour-emoji font and won't render emoji flags at all — so a 🇩🇰 would show as "DK" or tofu. Drawing
// real SVGs sidesteps the platform entirely.
const FLAGS = Flags as Record<
  string,
  React.ComponentType<React.SVGProps<SVGSVGElement> & { title?: string }> | undefined
>

interface CountryFlagProps {
  country?: string | null
  /** Sizing/style classes — pass a width+height (3:2 ratio), e.g. "h-4 w-6". */
  className?: string
}

// A country's flag as an SVG, falling back to a globe glyph when the country is unknown or has no asset.
const CountryFlag: React.FC<CountryFlagProps> = ({ country, className = '' }) => {
  const alpha2 = countryAlpha2(country)
  const Flag = alpha2 ? FLAGS[alpha2] : undefined

  if (Flag) {
    return (
      <Flag
        title={countryLabel(country)}
        className={`inline-block rounded-[2px] object-cover ${className}`}
      />
    )
  }

  return <FontAwesomeIcon icon={faGlobe} className={className} aria-hidden />
}

export default CountryFlag
